String.prototype.normaliceAccents = function() {
  if (this !== null) {
    return this?.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }
  return null;
};
